import { useEffect, useState } from 'react';
import styles from './App.module.css';
import api from './api/axios';
import { FaCheck, FaTimes, FaExclamation } from 'react-icons/fa';
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import './css/notifications.css';
import notifications from './components/notifications';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { format, parseISO } from 'date-fns';
import CalendarioEntrevista from './components/Graficos/CalendarioEntrevista';
import { isAuthenticated } from './index';

function App() {
  const {  userCpf, userPermission } = isAuthenticated();

  const [pendenciaOn, setPendenciaOn] = useState([]);
  const [notificationType, setNotificationType] = useState(0);

  const [usersList, setUsersList] = useState([]);
  const [vendedoresList, setVendedoresList] = useState([]);

  const [quarentenaData, setQuarentenaData] = useState(0);
  const [filteredData2, setFilteredData2] = useState([]);


  //   const [agendamentos, setAgendamentos] = useState([]);
  // const [usersListProd, setUsersListProd] = useState([]);
  // const [produtoresList, setProdutoresList] = useState([]);
  // const [filteredDataProd, setFilteredDataProd] = useState([]);



  async function updateStatus(id, statusDef) {
    try {
      const res = await api.post('/updateStatus', {
        id,
        status: statusDef,
      });

      if (res.data === true) {
        await refreshUsers();
      }
    } catch (error) {
      console.log(error);
      console.log("erro na funcao updatestatis");
    }
  }

  async function refreshUsers() {
    const res = await api.get('/clientes');
    // const resProd = await api.get('/produzir');
    // const resAgendamento = await api.get('/agendamentos');

    setUsersList(res.data);
    // setUsersListProd(resProd.dataProd || []);
    // setFilteredDataProd(resProd.dataProd || []);
    // setAgendamentos(resAgendamento.data || []);
  }

  useEffect(() => {
    async function loadData() {
      try {
        const res = await api.get(`/clientes?userPermission=${userPermission}&CPF=${userCpf}`);
        // const resProd = await api.get('/clientesProd');

        setUsersList(res.data || []);
        // setUsersListProd(resProd.data || []);
        // setFilteredDataProd(resProd.data || []);

        const resVendedoresProdutores = await api.get('/vendedores-produtores');

        if (resVendedoresProdutores.data && Array.isArray(resVendedoresProdutores.data.data)) {
          const users = resVendedoresProdutores.data.data;
          const usersFiltrado = users.filter((user) => user.is_vendedor === 1);

          setVendedoresList(usersFiltrado);
          // setProdutoresList(users.filter((user) => user.is_produtor === 1));

          const vendedoresComPendencias = usersFiltrado.filter((user) =>
            res.data.some(
              (item) =>
                item.vendedor === user.cpf &&
                (item.status === 1 || item.status === 3 || item.status === 5)
            )
          );

          setPendenciaOn(vendedoresComPendencias);
        } else {
          console.error('Formato inesperado da resposta:', resVendedoresProdutores.data);
        }

        // const response = await api.get('/agendamentos');
        // setAgendamentos(response.data || []);
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
      }
    }

    loadData();
  }, [userPermission, userCpf]);

  useEffect(() => {
    if (notificationType && notifications[notificationType]) {
      notifications[notificationType]();
      setNotificationType(0);
    }
  }, [notificationType]);

  useEffect(() => {
    if (quarentenaData === 0) {
      setFilteredData2([]);
    } else if (quarentenaData === 10) {
      setFilteredData2(
        usersList.filter((item) => item.status === 1 || item.status === 3 || item.status === 5)
      );
    } else {
      setFilteredData2(
        usersList.filter(
          (item) =>
            (item.status === 1 || item.status === 3 || item.status === 5) &&
            item.vendedor === quarentenaData
        )
      );
    }
  }, [quarentenaData, usersList]);


  return (
    <div className={styles.app}>
      <NotificationContainer />

      <div className={`${styles.corTitulo} ${styles.bluea}`}>
        <p className={styles.titulo}>Pendências</p>
      </div>

      <div className={styles.cadastroClienteContainer}>
        <div className={styles.tituloContainer}></div>
        <div className={styles.divisor}></div>

        <div className={styles.filtroDeClientesContainer}>
          <div className={styles.filterOptionsContainer}>
            <div className={styles.containerVendedor}>
              <div className={styles.inputStyleVendedor}>
                {pendenciaOn.map((user) => {
                  const totalPendencias =
                    usersList.filter((item) => item.vendedor === user.cpf && item.status === 1).length +
                    usersList.filter((item) => item.vendedor === user.cpf && item.status === 3).length +
                    usersList.filter((item) => item.vendedor === user.cpf && item.status === 5).length;

                  return (
                    <div key={user.cpf} className={styles.setPendenciaDiv}>
                      <button
                        className={styles.setPendenciaButton}
                        onClick={() => setQuarentenaData(user.cpf)}
                      >
                        {user.nome}
                      </button>
                      <div className={styles.bolha}>{totalPendencias}</div>
                    </div>
                  );
                })}

                <div className={styles.setPendenciaDiv}>
                  <button
                    className={styles.setPendenciaButton}
                    onClick={() => setQuarentenaData(10)}
                  >
                    ALL
                  </button>
                  <div className={styles.bolha}>
                    {
                      usersList.filter(
                        (item) => item.status === 1 || item.status === 3 || item.status === 5
                      ).length
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.flex}>
          <div className={styles.column}>
            <div className={`${styles.editIconBox} ${styles.green} ${styles.margin5}`}>
              <p className={styles.icon2}><FaCheck /></p>
              <p className={styles.legenda}>&nbsp;&nbsp;Finalizar cliente</p>
            </div>
          </div>

          <div className={styles.column}>
            <div className={`${styles.editIconBox} ${styles.yellow} ${styles.margin5}`}>
              <p className={styles.icon2}><FaExclamation /></p>
              <p className={styles.legenda}>&nbsp;&nbsp;Garantia entregue</p>
            </div>
          </div>

          <div className={styles.column}>
            <div className={`${styles.editIconBox} ${styles.red} ${styles.margin5}`}>
              <p className={styles.icon2}><FaTimes /></p>
              <p className={styles.legenda}>&nbsp;&nbsp;Retomar fila</p>
            </div>
          </div>
        </div>

        <div className={styles.usersListContainer}>
          {filteredData2.map((user) => {
            let dataHorarioEntrevista = '';

            if (user.entrevista) {
              try {
                const entrevista = JSON.parse(user.entrevista);
                if (entrevista.data_horario) {
                  dataHorarioEntrevista = format(parseISO(entrevista.data_horario), 'dd-MM-yy');
                }
              } catch (error) {
                console.error('Erro ao parsear entrevista:', error);
              }
            }

            return (
              <div
                key={user.id}
                className={
                  user.status === "1"
                    ? styles.userContainer
                    : user.status === "3" || user.status === "5"
                      ? `${styles.userContainer} ${styles.backgroundSenha}`
                      : styles.userContainer
                }
                onClick={() => {
                  const input = document.createElement('input');
                  input.setAttribute('value', user.login);
                  document.body.appendChild(input);
                  input.select();

                  try {
                    document.execCommand('copy');
                    console.log('Termo copiado: ' + user.login);
                    document.body.removeChild(input);
                    setNotificationType(19);
                  } catch (err) {
                    console.log('Unable to copy!');
                    document.body.removeChild(input);
                  }
                }}
              >
                <div className={styles.userContainer3}>
                  <div className={styles.editContainer}>
                    <div className={styles.editIconBoxes}>
                      <p
                        style={{
                          padding: "5px",
                          backgroundColor: "var(--corPrimaria)",
                          borderRadius: "10px",
                          color: "white",
                          marginRight: "5vw"
                        }}
                      >
                        {dataHorarioEntrevista}
                      </p>

                      <div
                        onClick={async () => {
                          await updateStatus(user.id, 2);
                        }}
                        className={`${styles.editIconBox} ${styles.green} ${styles.margin5}`}
                      >
                        <p className={styles.icon2}><FaCheck /></p>
                      </div>

                      <div
                        onClick={async () => {
                          await updateStatus(user.id, 4);
                        }}
                        className={`${styles.editIconBox} ${styles.yellow} ${styles.margin5}`}
                      >
                        <p className={styles.icon2}><FaExclamation /></p>
                      </div>

                      <div
                        onClick={async () => {
                          await updateStatus(user.id, 0);
                        }}
                        className={`${styles.editIconBox} ${styles.red} ${styles.margin5}`}
                      >
                        <p className={styles.icon2}><FaTimes /></p>
                      </div>
                    </div>

                    <div className={styles.editLogin}>
                      {user.vendedor !== 0 ? (
                        <p className={styles.icon2}>
                          {vendedoresList.find((vendedor) => vendedor.cpf === user.vendedor)?.nome ||
                            'Vendedor não encontrado'}
                        </p>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div>
                  <p className={styles.loginContainer2} id="copiar2">
                    {user.login}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div style={{ marginTop: "40px" }}>
        <CalendarioEntrevista />
      </div>

      <div
        className={styles.sliderContainer}
        style={{ marginTop: "20px" }}
      >
        <a
          href="https://chromewebstore.google.com/detail/ds-editor/hicdanpokmlhkkcpblhmjckieofeipid"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/banner/banner1wp.webp"
            className={styles.sliderImage}
            alt="Banner da extensão DS Editor"
          />
        </a>
      </div>

      <div className={styles.buttonBigDiv}>
        <a href="/produzir" className={`${styles.buttonBig} ${styles.green}`}>
          PRODUZIR
        </a>
        <a
          href="/producao"
          className={styles.buttonBig}
          style={{ backgroundColor: "black", color: "white" }}
        >
          PRODUÇÃO
        </a>
        <a href="/financeiro" className={`${styles.buttonBig} ${styles.yellow}`}>
          FINANÇAS
        </a>
        <a href="/monitorar" className={`${styles.buttonBig} ${styles.red}`}>
          MONITORAR
        </a>
        <a href="/adm" className={`${styles.buttonBig} ${styles.blue}`}>
          ADM
        </a>
        <a href="/parceiros" className={`${styles.buttonBig} ${styles.roxo}`}>
          PARCEIROS
        </a>
      </div>

      {/* <div
        className={styles.cadastroItems06}
        style={{
          borderRadius: "20px",
          backgroundColor: "white",
          margin: "40px",
          maxWidth: "600px",
        }}
      >
        <ChatGPT contextMessage={meuContexto} />
      </div> */}

      <div
        className={styles.sliderContainer}
        style={{ marginTop: "20px" }}
      >
        <a href="https://gabrielsenna.com/ideias-para-melhorias/">
          <img
            src="/banner/melhoria.webp"
            className={styles.sliderImage}
            alt="Banner de ideias para melhorias"
          />
        </a>
      </div>
    </div>
  );
}

export default App;